import axios from 'axios'

import { formatDateForServer, parseDateFromServer } from '../../../functions/dateHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

import {
  savingChartPhase,
  errorSavingChartPhase,
  errorSavingChartDate,
  alertChartHasBeenSaved,
  handleChartFieldChange
 } from './chartFormReducer'


const defaultState = {
  admissionDate: null,
  admissionType: '',
  admissionTypeOtherText: '',
  admissionDiagnoses: '',

  //additionalDiagnoses bools and char fields
  myocardialInfarction: false,
  congestiveHeartFailure: false,
  peripheralVascularDisease: false,
  cerebrovascularDiseaseTransientIschemicAttacks: false,
  dementia: false,
  chronicPulmonaryDisease: false,
  connectiveTissueDisease: false,
  pepticUlcerDisease: false,
  mildLiverDisease: false,
  moderateSevereLiverDisease: false,
  diabetesMellitusUncomplicated: false,
  diabetesWithEndOrganDamage: false,
  hemiplegia: false,
  moderateOrSevereRenalDisease: false,
  solidTumorWithoutMetastasisLastFiveYears: false,
  metastaticSolidTumor: false,
  metastaticSolidTumorPrimarySite: '',
  metastaticSolidTumorMetastaticSites: '',
  leukemia: false,
  lymphoma: false,
  hiv: false,
  hiv_treatment: '',
  cysticFibrosis: false,
  bronchiectasis: false,
  emphysema: false,
  multipleMyeloma: false,
  muscularSkeletalAbnormalityDegenerativeDisease: false,
  severeBurns: false,
  covid: false,
  febrileNeutropenia: false,
  additionalDiagnosesOther: false,
  additionalDiagnosesOtherText: '',
  no_pre_existing_conditions: false,
  pregnancy: false,
  pregnancy_trimester: '',

  //infectionRiskFactors bools and char fields
  carbapenemBacterialInfectionHistory: false,
  hospitalAdmissionsInPastSixMonths: false,
  hospitalAdmissionsInPastSixMonthsText: '',
  transplantWithinNinetyDays: false,
  traumaSurgery: false,
  traumaSurgeryText: '',
  cytotoxicChemotherapy: false,
  highDoseCorticosteroids: false,
  recentTravelToForeignCountry: false,
  recentTravelToForeignCountryText: '',
  carbapenemInPriorThirtyDays: false,
  ventilatorBeforeCulture: false,
  bacterialInfectionRiskFactorsOther: false,
  bacterialInfectionRiskFactorsOtherText: '',
  no_carbapenem_bacterial_infection_risk_factors: false,

  hospitalAdmissionInfoUrl: null,
}

export default function hospitalAdmissionFormReducer(state = defaultState, action) {
  switch (action.type) {
    case "CHANGE_EDIT_CHART_PHASE":
      return { ...state, chartPhase: action.payload }
    case "HANDLE_HOSPITAL_ADMISSION_FORM_FIELD_CHANGE":
      return { ...state, [action.payload.key]: action.payload.value }
    case "CHART_HOSPITAL_ADMISSION_INFO_HAS_BEEN_SAVED":
      return { ...state, hospitalAdmissionInfoUrl: action.payload.hospitalAdmissionInfoUrl }
    case "SET_CHART_FROM_SERVER_TO_FORM":
      const hospitalAdmission = resetHospitalAdmissionFormFromServer(action.payload)
      return {
        ...state,
        ...hospitalAdmission,
      }
    case "MARK_CHART_AS_COMPLETED":
      return defaultState
    case "CHART_HAS_BEEN_DELETED":
      return defaultState
    default:
      return state
  }
}


export const handleHospitalAdmissionChartFieldChange = (key, value) => {
  return { type: "HANDLE_HOSPITAL_ADMISSION_FORM_FIELD_CHANGE", payload: { key, value } }
}


const chartHospitalAdmissionInfoHasBeenSaved = (hospitalAdmissionInfoUrl, goToNextPhase) => {
  return {
    type: "CHART_HOSPITAL_ADMISSION_INFO_HAS_BEEN_SAVED",
    payload: { hospitalAdmissionInfoUrl, goToNextPhase},
  }
}


export const submitChartHospitalAdmissionInfo = (props, goToNextPhase) => {
  const { hospitalAdmissionInfoUrl } = props

  return (dispatch, getState) => {
    const chartIsSaving = getState().chartFormReducer.savingChartPhase
    if (chartIsSaving) {
      return dispatch({ type: '' })
    }

    dispatch(savingChartPhase())

    const hospitalAdmission = formatHopitalAdmissionForServer(props)
    if (props.override_date) {
      hospitalAdmission.override_date = true
      hospitalAdmission.reason = props.dateOverrideReason
    }

    let method, url
    if (hospitalAdmissionInfoUrl) {
      method = "PATCH"
      url = hospitalAdmissionInfoUrl
    } else {
      method = "POST"
      url = `${getServerUrl()}/hospital-admissions/`
    }

    axios({
      method,
      url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
      data: hospitalAdmission,
    })
    .then(response => {
      alertChartHasBeenSaved(props)
      dispatch(chartHospitalAdmissionInfoHasBeenSaved(response.data.url, goToNextPhase))
    })
    .catch(error => {
      if (error.response.data.non_field_errors) {
        let joinError = error.response.data.non_field_errors.join(' ')
        let firstKey = joinError.split('[')[1].split(',')[0]
        if (joinError.split('[')[1].includes(',')) {
          //thirdKey will always point to override, if true date is overridable
          let secondKey = joinError.split('[')[1].split(',')[1].split(']')[0].split(' ')[1]
          let thirdKey = joinError.split('[')[1].split(',')[2].split(']')[0].split(' ')[1]

          if (hospitalAdmission[`${firstKey}`]) {
            let firstArr = firstKey.split('_')
            let firstJoined = firstArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let firstCamelCase = firstJoined.charAt(0).toLowerCase() + firstJoined.slice(1)
            if (props.chartDateErrorMessage === firstCamelCase) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                // hospitalAdmission.hospitalAdmissionInfoUrl = props.hospitalAdmissionInfoUrl
                dispatch(handleChartFieldChange('hospitalAdmissionDateOverride', props))
              } else {
                props[`${firstCamelCase}`] = null
                dispatch(submitChartHospitalAdmissionInfo(props))
                dispatch(handleHospitalAdmissionChartFieldChange(firstCamelCase, null))
              }
            }
          }
          if (hospitalAdmission[`${secondKey}`]) {
            let secondArr = secondKey.split('_')
            let secondJoined = secondArr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
            let secondCamelCase = secondJoined.charAt(0).toLowerCase() + secondJoined.slice(1)
            if (props.chartDateErrorMessage === secondCamelCase) {
              if (thirdKey === 'True') {
                //this will trigger the date override modal if the date can be overriden
                dispatch(handleChartFieldChange('triggerDateOverrideModal', true))
                dispatch(handleChartFieldChange('hospitalAdmissionDateOverride', props))
              } else {
                props[`${secondCamelCase}`] = null
                dispatch(submitChartHospitalAdmissionInfo(props))
                dispatch(handleHospitalAdmissionChartFieldChange(secondCamelCase, null))
              }
            }
          }
        } else {
          let arr = firstKey.split('_')
          let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
          let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
          if (props.chartDateErrorMessage === camelCase) {
            props[`${camelCase}`] = null
            dispatch(submitChartHospitalAdmissionInfo(props))
            dispatch(handleHospitalAdmissionChartFieldChange(camelCase, null))
          }
        }
        return dispatch(errorSavingChartDate(error, "Hospital Admission"))
      } else {
        dispatch(errorSavingChartPhase(error, "Hospital Admission", dispatch))
      }
    })
  }
}



const formatHopitalAdmissionForServer = (props) => {
  return {
    patient_chart: props.patientChartUrl || null,

    admission_date: props.admissionDate ? formatDateForServer(props.admissionDate) : null,
    admission_type: props.admissionType || null,
    admission_type_other_text: props.admissionTypeOtherText || null,
    admission_diagnoses: props.admissionDiagnoses || null,
    //additionalDiagnoses bools and char fields
    myocardial_infarction: props.myocardialInfarction,
    congestive_heart_failure: props.congestiveHeartFailure,
    peripheral_vascular_disease: props.peripheralVascularDisease,
    cerebrovascular_disease_transient_ischemic_attacks: props.cerebrovascularDiseaseTransientIschemicAttacks,
    dementia: props.dementia,
    chronic_pulmonary_disease: props.chronicPulmonaryDisease,
    connective_tissue_disease: props.connectiveTissueDisease,
    peptic_ulcer_disease: props.pepticUlcerDisease,
    mild_liver_disease: props.mildLiverDisease,
    moderate_severe_liver_disease: props.moderateSevereLiverDisease,
    diabetes_mellitus_uncomplicated: props.diabetesMellitusUncomplicated,
    diabetes_with_end_organ_damage: props.diabetesWithEndOrganDamage,
    hemiplegia: props.hemiplegia,
    moderate_or_severe_renal_disease: props.moderateOrSevereRenalDisease,
    solid_tumor_without_metastasis_last_five_years: props.solidTumorWithoutMetastasisLastFiveYears,
    metastatic_solid_tumor: props.metastaticSolidTumor,
    metastatic_solid_tumor_primary_site: props.metastaticSolidTumorPrimarySite || null,
    metastatic_solid_tumor_metastatic_sites: props.metastaticSolidTumorMetastaticSites || null,
    leukemia: props.leukemia,
    lymphoma: props.lymphoma,
    hiv: props.hiv,
    hiv_treatment: props.hiv_treatment,
    cystic_fibrosis: props.cysticFibrosis,
    bronchiectasis: props.bronchiectasis,
    emphysema: props.emphysema,
    multiple_myeloma: props.multipleMyeloma,
    muscular_skeletal_abnormality_degenerative_disease: props.muscularSkeletalAbnormalityDegenerativeDisease,
    severe_burns: props.severeBurns,
    covid_19: props.covid,
    febrile_neutropenia: props.febrileNeutropenia,
    additional_diagnoses_other: props.additionalDiagnosesOther,
    additional_diagnoses_other_text: props.additionalDiagnosesOtherText,
    no_pre_existing_conditions: props.no_pre_existing_conditions,
    pregnancy: props.pregnancy,
    pregnancy_trimester: props.pregnancy_trimester,

    //infectionRiskFactors bools and char fields
    carbapenem_bacterial_infection_history: props.carbapenemBacterialInfectionHistory,
    hospital_admissions_in_past_six_months: props.hospitalAdmissionsInPastSixMonths,
    hospital_admissions_in_past_six_months_text: props.hospitalAdmissionsInPastSixMonthsText,
    transplant_within_ninety_days: props.transplantWithinNinetyDays,
    trauma_surgery_within_three_months: props.traumaSurgery,
    trauma_surgery_text: props.traumaSurgeryText,
    cytotoxic_chemotherapy: props.cytotoxicChemotherapy,
    high_dose_corticosteroids: props.highDoseCorticosteroids,
    recent_travel_to_foreign_country: props.recentTravelToForeignCountry,
    recent_travel_to_foreign_country_text: props.recentTravelToForeignCountryText,
    carbapenem_in_prior_thirty_days: props.carbapenemInPriorThirtyDays,
    ventilator_before_culture: props.ventilatorBeforeCulture,
    bacterial_infection_risk_factors_other: props.bacterialInfectionRiskFactorsOther,
    bacterial_infection_risk_factors_other_text: props.bacterialInfectionRiskFactorsOtherText || null,
    no_carbapenem_bacterial_infection_risk_factors: props.no_carbapenem_bacterial_infection_risk_factors,
  }
}



const resetHospitalAdmissionFormFromServer = (patientChart) => {
  if (!patientChart.hospital_admission) {
    return {}
  }

  const hospitalAdmission = patientChart.hospital_admission
  return {
    admissionDate: parseDateFromServer(hospitalAdmission.admission_date),
    admissionType: hospitalAdmission.admission_type || '',
    admissionTypeOtherText: hospitalAdmission.admission_type_other_text || '',
    admissionDiagnoses: hospitalAdmission.admission_diagnoses || '',

    //additionalDiagnoses bools and char fields
    myocardialInfarction: hospitalAdmission.myocardial_infarction,
    congestiveHeartFailure: hospitalAdmission.congestive_heart_failure,
    peripheralVascularDisease: hospitalAdmission.peripheral_vascular_disease,
    cerebrovascularDiseaseTransientIschemicAttacks: hospitalAdmission.cerebrovascular_disease_transient_ischemic_attacks,
    dementia: hospitalAdmission.dementia,
    chronicPulmonaryDisease: hospitalAdmission.chronic_pulmonary_disease,
    connectiveTissueDisease: hospitalAdmission.connective_tissue_disease,
    pepticUlcerDisease: hospitalAdmission.peptic_ulcer_disease,
    mildLiverDisease: hospitalAdmission.mild_liver_disease,
    moderateSevereLiverDisease: hospitalAdmission.moderate_severe_liver_disease,
    diabetesMellitusUncomplicated: hospitalAdmission.diabetes_mellitus_uncomplicated,
    diabetesWithEndOrganDamage: hospitalAdmission.diabetes_with_end_organ_damage,
    hemiplegia: hospitalAdmission.hemiplegia,
    moderateOrSevereRenalDisease: hospitalAdmission.moderate_or_severe_renal_disease,
    solidTumorWithoutMetastasisLastFiveYears: hospitalAdmission.solid_tumor_without_metastasis_last_five_years,
    metastaticSolidTumor: hospitalAdmission.metastatic_solid_tumor,
    metastaticSolidTumorPrimarySite: hospitalAdmission.metastatic_solid_tumor_primary_site || '',
    metastaticSolidTumorMetastaticSites: hospitalAdmission.metastatic_solid_tumor_metastatic_sites || '',
    leukemia: hospitalAdmission.leukemia,
    lymphoma: hospitalAdmission.lymphoma,
    hiv: hospitalAdmission.hiv,
    hiv_treatment: hospitalAdmission.hiv_treatment,
    cysticFibrosis: hospitalAdmission.cystic_fibrosis,
    bronchiectasis: hospitalAdmission.bronchiectasis,
    emphysema: hospitalAdmission.emphysema,
    multipleMyeloma: hospitalAdmission.multiple_myeloma,
    muscularSkeletalAbnormalityDegenerativeDisease: hospitalAdmission.muscular_skeletal_abnormality_degenerative_disease,
    severeBurns: hospitalAdmission.severe_burns,
    covid: hospitalAdmission.covid_19,
    febrileNeutropenia: hospitalAdmission.febrile_neutropenia,
    additionalDiagnosesOther: hospitalAdmission.additional_diagnoses_other,
    additionalDiagnosesOtherText: hospitalAdmission.additional_diagnoses_other_text,
    no_pre_existing_conditions: hospitalAdmission.no_pre_existing_conditions,
    pregnancy: hospitalAdmission.pregnancy,
    pregnancy_trimester: hospitalAdmission.pregnancy_trimester || '',


    //infectionRiskFactors bools and char fields
    carbapenemBacterialInfectionHistory: hospitalAdmission.carbapenem_bacterial_infection_history,
    hospitalAdmissionsInPastSixMonths: hospitalAdmission.hospital_admissions_in_past_six_months,
    hospitalAdmissionsInPastSixMonthsText: hospitalAdmission.hospital_admissions_in_past_six_months_text,
    transplantWithinNinetyDays: hospitalAdmission.transplant_within_ninety_days,
    traumaSurgery: hospitalAdmission.trauma_surgery_within_three_months,
    traumaSurgeryText: hospitalAdmission.trauma_surgery_text,
    cytotoxicChemotherapy: hospitalAdmission.cytotoxic_chemotherapy,
    highDoseCorticosteroids: hospitalAdmission.high_dose_corticosteroids,
    recentTravelToForeignCountry: hospitalAdmission.recent_travel_to_foreign_country,
    recentTravelToForeignCountryText: hospitalAdmission.recent_travel_to_foreign_country_text,
    carbapenemInPriorThirtyDays: hospitalAdmission.carbapenem_in_prior_thirty_days,
    ventilatorBeforeCulture: hospitalAdmission.ventilator_before_culture,
    bacterialInfectionRiskFactorsOther: hospitalAdmission.bacterial_infection_risk_factors_other,
    bacterialInfectionRiskFactorsOtherText: hospitalAdmission.bacterial_infection_risk_factors_other_text || '',
    no_carbapenem_bacterial_infection_risk_factors: hospitalAdmission.no_carbapenem_bacterial_infection_risk_factors,


    hospitalAdmissionInfoUrl: hospitalAdmission.url || null,
  }
}
